import React from 'react';
import Icon from './Icon';

const LayersIcon = (props) => (
    <Icon {...props}>
        <path d="M4 4h16v16H4zM8 8h8v8H8zM12 12h4v4h-4z" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

export default LayersIcon;